/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { GET_ALL_LAYOUT_ARTE } from 'services/LayoutArte';
import { GET_SELECT_LIST } from 'services/MaterialComunicacao'
import SingleSelect from 'components/_base/SelectSingle';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/dist/styles.css";

const ContentLayoutArtes = () => {

  const [listLayoutArtes, setListLayoutArtes] = useState([]);
  const [listMateriais, setListMateriais] = useState([]);
  const [materialIdSelecionado, setMaterialIdSelecionado] = useState();
  const [lightbox, setLightbox] = useState({
    isOpen: false,
    image: null
  });

  useEffect(() => {
    getLayouts();
    getMateriais();
  }, []);

  async function getLayouts() {
    let result = await GET_ALL_LAYOUT_ARTE();
    setListLayoutArtes(result.value)
  }

  async function getMateriais() {
    let materiais = await GET_SELECT_LIST();
    setListMateriais(materiais.value)
  }

  let filteredLayouts = listLayoutArtes;
  if (materialIdSelecionado > 0) {
    filteredLayouts = listLayoutArtes.filter(x => x.layoutArteMateriaisComunicacao.filter(y => y.materialComunicacaoId == materialIdSelecionado).length > 0);
  }

  let teste = {
    nome: 'diego'
  };

  return (
    <div>
      <div className="row">
        <div className="col-lg-3 p-5">
          <SingleSelect options={listMateriais} onChange={(value) => setMaterialIdSelecionado(value)} value={materialIdSelecionado} />
        </div>
      </div>

      <hr />


      <Lightbox
        open={lightbox.isOpen}
        close={() => setLightbox({
          isOpen: false,
          imagem: null
        })}
        slides={[
          { src: lightbox.image }
        ]}
        render={{
          buttonPrev: () => null,
          buttonNext: () => null
        }}
      />

      <div className="row">
        {
          filteredLayouts.map(x =>

            <div className="col-lg-3 mb-5 p-5">
              <div>
                <img src={x.urlImagem} className="img-fluid cursor-pointer" onClick={() => setLightbox({
                  isOpen: true,
                  image: x.urlImagem
                })} />
              </div>
              <div>{x.descricao}</div>

            </div>

          )
        }
      </div>
    </div >

  )
};

export default ContentLayoutArtes;
